const variables = {
  // defaultURL: '',
  defaultURL: 'https://notifications.meals4u.net',
  danger: 'danger',
  warning: 'warning',
  success: 'success',
  server_error : 'Error'
};
export { variables };
